'use strict';

var floatingLabel = require('brand_core/components/floatingLabel');
var scrollAnimate = require('brand_core/components/scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    if (data.success) {
        $('.subscribe-email').addClass('d-none');
        $('#email-singup').trigger('reset');
        $('.subscribe-response').removeClass('d-none').text(data.msg);
    } else {
        if ($('.email-signup-error').length === 0) {
            $('#email-singup .form-inline').append(
                '<div class="email-signup-error"><i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span class="email-signup-error-text"></span></div>'
             );
        }

        $('#email-singup input.form-control').addClass('is-invalid');
        $('.email-signup-error-text').append(data.msg);
    }
    $('input.form-control').focus(function () {
        $('.subscribe-email').removeClass('d-none');
        $('.subscribe-response').addClass('d-none');
    });
    setTimeout(function () {
        $('.email-signup-error').remove();
        $('#email-singup input.form-control').removeClass('is-invalid');
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Enables the submit button when valid email entered
 */
function enableKlaviyoSubmitButton() {
    var $signUpId = $('#email-singup');
    var flag = $signUpId.find('input[type="email"]').attr('aria-invalid').trim().toLowerCase();
    var $emailSignup = $signUpId.find('button');

    if (flag === 'true') {
        $emailSignup.prop('disabled', true);
        $emailSignup.removeClass('enable-btn');
    } else {
        $emailSignup.prop('disabled', false);
        $emailSignup.addClass('enable-btn');
    }
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var emailId = $('input[name=hpEmailSignUp]').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });

    $(document.body).on('blur', '#email-singup input[type="email"]', function () {
        setTimeout(function () {
            enableKlaviyoSubmitButton();
        }, 2); // call after 2 milli second
    });
};

var scrollTopbar = function () {
    var scroll = $(window).scrollTop();
    if (scroll > 200) {
        $('.back-to-top').addClass('show');
    } else {
        $('.back-to-top').removeClass('show');
    }
};
scrollTopbar();

$(window).scroll(function () {
    scrollTopbar();
});

$(window).on('load', function () {
    floatingLabel.loadFloatingLabel();
});
